var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"mx-2",attrs:{"fab":"","dark":"","x-small":"","color":"primary","id":"change-theme-button"},on:{"click":function($event){return _vm.changeTheme()}}},[_c('v-icon',{staticClass:"btn-icon"},[_vm._v(" "+_vm._s(_vm.themeIcon)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }